import styled from 'styled-components'
import { TextInputProps } from './index'

export const Wrapper = styled.div`
  margin-bottom: 1.5rem;
`

export const Input = styled.input.attrs({ className: 'input' })<TextInputProps>`
  display: block;
  border-radius: 4px;
  border: 1px solid #e3e7ed;
  background-color: #f7f9fc;
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #152735;
  background-clip: padding-box;
  transition: border-color 0.15s;
  box-sizing: border-box;

  ::placeholder {
    color: #b5b5b5;
  }

  :focus {
    border-color: ${props => (props.errorLabel ? '#D82C2C' : '#89919C')};
    outline: 0;
  }

  border-color: ${props => props.errorLabel && '#D82C2C'};

  :-webkit-autofill,
  :-webkit-autofill:hover,
  :-webkit-autofill:focus,
  :-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px #f7f9fc inset !important;
  }
`

export const HelperText = styled.span`
  color: #585d64;
  font-size: 11px;
  line-height: 14px;
`
export const TooltipWrap = styled.div`
  margin-left: auto;
`
export const LabelWrap = styled.div`
  display: flex;
  align-content: space-between;
  width: 100%;
`